import {
    deleteAuthenticated,
    getAuthenticated,
    patchAuthenticated,
    postAuthenticated
} from '../../../../../services/RestTemplate';

const usersApi = '/users';

export const getUsers = () => getAuthenticated(usersApi);

export const getUserById = userId => {
    const getUserByIdUrl = usersApi + `/${userId}`;
    return getAuthenticated(getUserByIdUrl);
};

export const updateUser = (userId, userDetails) => {
    const updateUserUrl = usersApi + `/${userId}`;

    return patchAuthenticated(updateUserUrl, userDetails);
};

export const addUserToTeam = (userId, params) => {
    const addUserToTeamUrl = usersApi + `/${userId}/teams`;

    return postAuthenticated(addUserToTeamUrl, params);
};

export const removeUserFromTeam = (userId, teamId) => {
    const addUserToTeamUrl = usersApi + `/${userId}/teams/${teamId}`;

    return deleteAuthenticated(addUserToTeamUrl);
};
